import { useId } from "react";

/** The eBookMe mark: a calendar page with a check, on the indigo→cyan gradient (same as the favicon). */
export function Logo({ className }: { className?: string }) {
  // Each instance needs its own gradient id: a copy inside a hidden sidebar would otherwise blank the others.
  const id = `ebookme-mark-${useId().replace(/:/g, "")}`;
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden>
      <defs>
        <linearGradient id={id} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#4f46e5" />
          <stop offset="1" stopColor="#06b6d4" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="16" fill={`url(#${id})`} />
      <rect x="14" y="17" width="36" height="33" rx="6" fill="#fff" />
      <rect x="14" y="17" width="36" height="9" rx="4" fill="#fff" opacity=".75" />
      <rect x="21" y="12" width="4" height="10" rx="2" fill="#fff" />
      <rect x="39" y="12" width="4" height="10" rx="2" fill="#fff" />
      <path d="M23 38.5l6 6 12-12" fill="none" stroke={`url(#${id})`} strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

/** "eBookMe" in headers. */
export function Lockup({ height = 18 }: { height?: number }) {
  return <Wordmark height={height} />;
}

/** The mark and the word; height drives the size. */
export function Wordmark({ height = 20, className = "" }: { height?: number; className?: string }) {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <span style={{ width: height * 1.25, height: height * 1.25 }} className="inline-flex">
        <Logo className="size-full" />
      </span>
      <span className="font-display font-bold text-ink tracking-tight leading-none" style={{ fontSize: height * 1.05 }}>
        e<span className="text-accent-text">Book</span>Me
      </span>
    </span>
  );
}

/** A company's own logo (PNG data) if it has one, else its name. */
export function CompanyMark({ name, logo, height = 28 }: { name: string; logo?: string; height?: number }) {
  if (logo) return <img src={logo.startsWith("data:") ? logo : `data:image/png;base64,${logo}`} alt={name} style={{ maxHeight: height, maxWidth: height * 6 }} className="object-contain" />;
  return <span className="font-display font-bold text-ink truncate" style={{ fontSize: height * 0.6 }}>{name}</span>;
}

export function MicrosoftMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 21 21" className={className} aria-hidden>
      <rect x="1" y="1" width="9" height="9" fill="var(--ms-red)" />
      <rect x="11" y="1" width="9" height="9" fill="var(--ms-green)" />
      <rect x="1" y="11" width="9" height="9" fill="var(--ms-blue)" />
      <rect x="11" y="11" width="9" height="9" fill="var(--ms-yellow)" />
    </svg>
  );
}
